import styled from 'styled-components';

import { theme } from "../../../configuration";

const TextArea = styled.textarea`
  padding: 10px;
  width: calc(100% - 20px);
  max-width: 400px;
  border: 1px solid ${theme.colours.border};
  border-radius: 4px;
  font-family: Arial, sans-serif;
`;

export default TextArea;

